var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-style"},[_c('span',{staticClass:"flag-icon",class:[ _vm.getFlagClass() ]}),_vm._v(" "),_c('span',{staticClass:"cx-search-icon cx-clickable-icon",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fas fa-search mx-2"})]),_vm._v(" "),_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(this.country.CountryName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }